import { FC } from 'react';
import { useQuery } from 'react-query';
import Tab from 'components/tabs/Tab';
import Tabs from 'components/tabs/Tabs';
import API from 'core/Api';
import { useParams } from 'react-router';
import IResponseData from 'types/api';
import { buildClientUrl } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import { ICategory } from '../types';

const CategoryTabs: FC = () => {
  const { id } = useParams<{ id: string }>();
  const { client } = useActiveClientContext();
  const { data } = useQuery<ICategory[], Error>('categories', (): Promise<ICategory[]> => {
    return API.get<IResponseData<ICategory>>('categories')
      .then(res => res.data?.items)
      .catch(err => {
        throw err;
      });
  });

  return (
    <Tabs
      className="mt-4 mb-4 pt-3 pb-4 pl-3 pr-3 justify-content-md-center justify-content-start"
      isCentered
      isCategoryWrapper
    >
      {data &&
        [...data]
          .sort((a, b) => a.id - b.id)
          .map(cat => (
            <Tab
              key={cat.id}
              isCategory
              isActive={id === cat.id.toString()}
              to={buildClientUrl(`/structure/multi-actions/${cat.id}`, client)}
            >
              {cat.name}
            </Tab>
          ))}
    </Tabs>
  );
};

export default CategoryTabs;
